import { useMutation } from 'react-query';
import type {
  ApiSignatureDocumentServiceRepository,
  SignSignatureDocumentServiceApiPayload,
} from '../services/repositories/implementations/ApiSignatureDocumentServiceRepository.ts';

export const useSignSignatureMutation = (signatureRepository: ApiSignatureDocumentServiceRepository) => {
  return useMutation<
    SignSignatureDocumentServiceApiPayload,
    unknown,
    { contentId: string; payload: SignSignatureDocumentServiceApiPayload }
  >({
    mutationFn: async ({ contentId, payload }) => {
      return signatureRepository.signSignature(contentId, payload);
    },
  });
};
